import React, { useState, useEffect } from "react"
import { CardBody, Col, Row, FormGroup, Label } from "reactstrap"
import * as Yup from "yup"

import { Button } from "components/Button"
import { TextInput } from "components/TextInput"
import { useFormik } from "formik"
import { GetUserListing } from "api/api.service"
import { AutoComplete } from "components/AutoComplete"
import Config from "Config"
import { UserRoles } from "../../../../constants"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"

const getWarehoseUsersAsOptions = (usersList = []) => {
   return usersList.map(item => ({
      label: item.user.firstName,
      value: item.user.id,
   }))
}
const AddEditWarehouse = ({
   btnText = "",
   data = null,
   isLoading = false,
   onSubmitForm = () => {},
}) => {
   let controller = new AbortController()
   let signal = controller.signal
   const objectSchema = Yup.object().shape({})

   const formik = useFormik({
      enableReinitialize: true,
      initialValues: {
         name: data?.warehouseName,
         address: data?.address,
         location: data?.location,
         user: data?.warehouseAssignments.length
            ? getWarehoseUsersAsOptions(data?.warehouseAssignments)
            : null,
      },
      validationSchema: Yup.object({
         name: Yup.string()
            .required("Enter warehouse name")
            .min(1, "Warehouse name should be minimum 1 characters long"),
         address: Yup.string()
            .nullable()
            // .required("Enter address")
            .min(1, "Address should be minimum 6 characters long"),
         location: Yup.string()
            .nullable()
            // .required("Enter location")
            .min(1, "Location should be minimum 6 characters long"),
         user: Yup.array()
            .nullable()
            .required("User is required")
            .min(1, "User is required"),
      }),
      onSubmit: values => {
         onSubmitForm(values)
      },
   })

   const [userListing, setUserListing] = useState({
      data: [],
      fetching: true,
      page: 1,
      Q: "",
      isDataAvailable: false,
   })

   useEffect(() => {
      getUserListingData(userListing.page)

      return () => {
         controller.abort()
      }
   }, [userListing.Q])

   const handleSearch = (value, callback) => {
      if (!value) return

      callback(prev => {
         return {
            ...prev,
            data: [],
            page: 1,
            Q: value,
         }
      })
   }

   const getUserListingData = page => {
      handleStateSet(setUserListing, { fetching: true, data: [] })
      GetUserListing(
         {
            limit: Config.LIMIT,
            ...(userListing.Q && { Q: userListing.Q }),
            page: page,
            type: UserRoles.Warehouse,
            status: "ACTIVE",
            // assigning: "notAssined",
         },
         signal
      )
         .then(res => {
            setUserListing(prev => ({
               ...prev,
               fetching: false,
               page: page + 1,
               isDataAvailable: res?.data.length === Config.LIMIT,
               data: (() => {
                  let test = res?.data.map(item => ({
                     ...item,
                     value: item.id,
                     label: `${item?.firstName} ${item?.lastName}`,
                  }))
                  return [...test, ...prev.data]
               })(),
            }))
         })
         .finally(() => {
            handleStateSet(setUserListing, { fetching: false })
         })
   }

   const handleStateSet = (callback = () => {}, keysObj = {}) => {
      callback(prev => {
         return {
            ...prev,
            ...(keysObj && keysObj),
         }
      })
   }

   const handleSelectedUser = selectedUser => {
      formik.setFieldValue("user", selectedUser)
   }

   return (
      <div className="d-flex flex-column align-items-center mb-4">
         <CardBody className="location-add-edit-card-container shadow-none">
            <form onSubmit={formik.handleSubmit}>
               <div className="location-form-handler">
                  <FormGroup className="d-flex location-add-edit-fg">
                     <Label
                        for="full name"
                        className="location-modal-label "
                        sm={3}
                     >
                        Name
                     </Label>
                     <Col sm={8} className="input-text-container ">
                        <TextInput
                           className="location-modal-input"
                           type="text"
                           name="name"
                           placeholder="Type here"
                           onChange={formik.handleChange}
                           onBlur={formik.handleBlur}
                           value={formik.values.name}
                        />
                     </Col>
                  </FormGroup>
                  <Row className="mb-3">
                     <Col sm={3}></Col>
                     <Col sm={8}>
                        {formik.touched.name && formik.errors.name ? (
                           <span className="error fs-14">
                              {formik.errors.name}
                           </span>
                        ) : null}
                     </Col>
                  </Row>
                  <FormGroup className="d-flex mb-0 location-add-edit-fg">
                     <Label
                        for="address"
                        className="location-modal-label "
                        sm={3}
                     >
                        Address
                     </Label>
                     <Col sm={8} className="input-text-container ">
                        <TextInput
                           className="location-modal-input "
                           type="text"
                           name="address"
                           placeholder="Type here"
                           onChange={formik.handleChange}
                           onBlur={formik.handleBlur}
                           value={formik.values.address}
                        />
                     </Col>
                  </FormGroup>
                  <Row className="mb-3">
                     <Col sm={3}></Col>
                     <Col sm={8}>
                        {formik.touched.address && formik.errors.address ? (
                           <span className="error fs-14">
                              {formik.errors.address}
                           </span>
                        ) : null}
                     </Col>
                  </Row>
                  <FormGroup className="d-flex mb-0 location-add-edit-fg">
                     <Label
                        for="location"
                        className="location-modal-label"
                        sm={3}
                     >
                        Location
                     </Label>
                     <Col sm={8} className="input-text-container ">
                        <TextInput
                           className="location-modal-input"
                           type="text"
                           name="location"
                           placeholder="Type here"
                           onChange={formik.handleChange}
                           onBlur={formik.handleBlur}
                           value={formik.values.location}
                        />
                     </Col>
                  </FormGroup>
                  <Row className="mb-3">
                     <Col sm={3} lg={3} md={3}></Col>
                     <Col sm={8}>
                        {formik.touched.location && formik.errors.location ? (
                           <span className="error fs-14">
                              {formik.errors.location}
                           </span>
                        ) : null}
                     </Col>
                  </Row>

                  <>
                     <FormGroup className="d-flex mb-0 location-add-edit-fg">
                        <label
                           // for="location"
                           className="location-modal-label"
                           // sm={3}
                        >
                           Warehouse Managers
                        </label>
                        <Col sm={8} className="input-text-container ">
                           <AutoComplete
                              isMulti
                              handleBlur={() =>
                                 setUserListing(prev => {
                                    return {
                                       ...prev,
                                       page: 1,
                                       Q: "",
                                    }
                                 })
                              }
                              onChange={handleSelectedUser}
                              onInputChange={val =>
                                 handleSearch(val, setUserListing)
                              }
                              placeholder="   Select warehouse managers"
                              classNamePrefix="add-new-req"
                              customStyles={autoCompleteStyles.STYLE_FOUR}
                              options={userListing?.data}
                              value={formik.values.user}
                              isLoading={userListing?.fetching}
                           />
                        </Col>
                     </FormGroup>
                     <Row className="mb-3">
                        <Col sm={3} lg={3} md={3}></Col>
                        <Col sm={8}>
                           {formik.touched.user && formik.errors.user ? (
                              <span className="error fs-14">
                                 {formik.errors.user}
                              </span>
                           ) : null}
                        </Col>
                     </Row>
                  </>
               </div>
               <div className="d-flex justify-content-center align-items-center">
                  <Button
                     isLoading={isLoading}
                     type="submit"
                     title={btnText ? btnText : undefined}
                     className="gt-btn-grad-primary my-4 button-width-vendor"
                  />
               </div>
            </form>
         </CardBody>
      </div>
   )
}

export default AddEditWarehouse
